<template>
  <div class="page-width">
    <div class="full_width">
      <div>
        <a
          v-for="(recruiter_name, idx) in recruiter_names"
          :key="idx"
          @click="selectRecruiter(recruiter_name)"
          class="button is-info recruiter_name"
          :class="{ 'is-outlined': recruiter_name != $route.query.recruiter }"
        >
          {{ recruiter_name }}
        </a>
      </div>
      <datatable
        title="Recruiter Payments"
        :response="data"
        :fields="fields"
        @delete="deleteRecruiterPayment"
        @edit_click="editRecruiterPayment"
        @create="createRecruiterPayment"
      >
      </datatable>
      <p v-if="total_amount" class="total_income">
        TOTAL: <b>{{ total_amount }}</b>
      </p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import TimeHelper from "@/classes/time_helper.js";
import Datatable from "@/components/Datatable";
export default {
  name: "recruiter-payments",
  data() {
    return {
      recruiter_names: [],
      fields: [
        {
          name: "Recruiter",
          value: "recruiter_name",
        },
        {
          name: "Amount",
          value: "amount",
        },
        {
          name: "Paid At",
          value: "paid_at",
          is_time: true,
        },
        {
          name: "Title",
          value: "title",
        },
      ],
      time_helper: new TimeHelper(),
      data: [],
      total_amount: undefined,
    };
  },
  created() {
    this.$network_utils.getListOfRecruiterNames().then((response) => {
      this.recruiter_names = response.map((i) => i.recruiter_name);
    });
    this.$network_utils
      .getRecruiterPayments({ recruiter_name: this.$route.query.recruiter })
      .then((response) => {
        this.data = response;
        this.total_amount = 0;
        this.data.forEach((recruiter_payment) => {
          this.total_amount += parseInt(recruiter_payment.amount);
        });
      });
  },
  methods: {
    editRecruiterPayment(data) {
      this.createModal({
        desigantor: "recruiter-payment-modal",
        component_name: "RecruiterPaymentForm",
        modal_title: `${data.recruiter_name} - ${
          data.amount
        } - ${this.time_helper.makeTimeReadable(data.paid_at)}`,
        data,
      });
    },
    createRecruiterPayment() {
      this.createModal({
        desigantor: "recruiter-payment-modal",
        component_name: "RecruiterPaymentForm",
        modal_title: "Create Recruiter Payment",
        is_create: true,
      });
    },
    deleteRecruiterPayment(delete_data) {
      let title = `${delete_data.recruiter_name} - ${
        delete_data.amount
      } - ${this.time_helper.makeTimeReadable(delete_data.paid_at)}`;
      this.createModal({
        designator: "delete-prompt",
        component_name: "DeletePrompt",
        modal_title: `Delete ${title}`,
        item_name: title,
        method: "deleteRecruiterPayment",
        method_params: { id: delete_data.id },
      });
    },
    selectRecruiter(recruiter_name) {
      let query = { recruiter: recruiter_name };
      if (this.$route.query.recruiter == recruiter_name) {
        query.recruiter = undefined;
      }
      this.$router.push({ name: this.$route.name, query });
    },
    ...mapMutations("modals", ["createModal"]),
  },
  components: {
    Datatable,
  },
};
</script>
<style scoped>
.recruiter_name {
  margin-right: 10px;
}
.total_income {
  margin-bottom: 30px;
}
</style>